import { styled } from '@mui/system';
import { Accordion, AccordionSummary, Box, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../constants/theme';
import { figmaLetterSpacing, Gapper } from '../../ui/utils';

export const Wrapper = styled(Gapper)({
  maxWidth: '808px',
  margin: '0 auto',
  padding: 0,
  alignItems: 'center',
});

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})(({ $isOpen }) => ({
  borderRadius: 30,
  background: $isOpen ? colors.iconBackground : colors.whiteText,
  border: `1px solid ${$isOpen ? 'black' : 'transparent'}`,
  boxShadow: `-4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)`,
  '&:before': { display: 'none' },
  '&:first-of-type, &:last-of-type': {
    borderRadius: 30,
  },
}));

export const StyledIconButton = styled(Box)(({ $isOpen }) => ({
  width: 50,
  height: 50,
  marginRight: 0,
  borderRadius: '20px',
  background: $isOpen ? colors.primary : colors.whiteText,
  color: $isOpen ? '#fff' : colors.mutedClay,
  border: `1px solid ${$isOpen ? 'transparent' : 'rgba(51, 38, 29, 0.3)'}`,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
}));

export const HeadingText = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '32px',
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  letterSpacing: figmaLetterSpacing(50, -1),
  textAlign: 'center',
  textWrap: 'nowrap',

  '& span': {
    fontSize: '22px',
  },
  [theme.breakpoints.down('1000')]: {
    whiteSpace: 'pre-line',
  },
  [theme.breakpoints.down(750)]: {
    textWrap: 'balance',
    whiteSpace: 'pre-line',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '40px',
    '& span': {
      fontSize: '30px',
    },
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '50px',
    lineHeight: '58px',
    '& span': {
      fontSize: '40px',
    },
  },
}));

export const QuestionText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  margin: 0,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 700,
  textAlign: 'left',
  fontSize: 20,
  letterSpacing: figmaLetterSpacing(20, 2),
  flex: 1,
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    fontWeight: 600,
  },
}));

export const AnswerText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontSize: '14px',
  textAlign: 'left',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontStyle: 'Regular',
  letterSpacing: figmaLetterSpacing(16, 2),
  whiteSpace: 'pre-line',
  maxWidth: '90%',
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
    lineHeight: '20px',
  },
}));

export const AccordionSummaryStyled = styled(AccordionSummary, {
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})(({ $isOpen, theme }) => ({
  padding: $isOpen ? '20px 20px 0 30px' : '20px 20px 20px 30px',
  '& .MuiAccordionSummary-content': {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  background: 'transparent',
  [theme.breakpoints.down('md')]: {
    padding: $isOpen ? '10px 10px 0 20px' : '10px 10px 10px 20px',
  },
}));

export const accordionDetailsStyles = {
  padding: '10px 20px 29px 30px',
  background: 'transparent',
};

export const ctaButtonContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
